import { AvailablePlan } from '@/data/services/plan/plan-service-types'
import { i18nTranslationHelper } from '@/i18n'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckIcon from '@mui/icons-material/Check'
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined'
import { ChipProps, useTheme } from '@mui/material'
import LabelChip from './label-chip'

type PlanChipBase = {
  size?: ChipProps['size']
  sx?: ChipProps['sx']
}

type PlanVariantProps = PlanChipBase & {
  variant?: 'plan'
  plan: AvailablePlan | undefined
  customLabel?: string
  onDelete?: () => void
}

type CoveredVariantProps = PlanChipBase & {
  variant: 'covered'
  customLabel?: string
}

export type PlanChipProps = PlanVariantProps | CoveredVariantProps

const PlanChip = (props: PlanChipProps) => {
  const theme = useTheme()
  const t = i18nTranslationHelper.getTComponents
  const { size = 'small', sx } = props

  // Variante "coberto pelo plano": ícone Check + paleta success (success-900 sobre success-200).
  // Hardcodado aqui (não via color="success" do LabelChip, que usaria os tons -700/-50).
  if (props.variant === 'covered') {
    return (
      <LabelChip
        icon={<CheckIcon color="inherit" />}
        label={props.customLabel ?? t('planCoveredChip.label')}
        size={size}
        sx={{
          color: theme.palette.success[900],
          backgroundColor: theme.palette.success[200],
          ...sx
        }}
      />
    )
  }

  // Variante "plano" (default): chip com ícone e cores do tier do plano.
  const { plan, customLabel, onDelete } = props
  if (!plan) {
    return null
  }

  return (
    <LabelChip
      icon={<WorkspacePremiumOutlinedIcon color="inherit" />}
      label={customLabel ?? plan.name}
      size={size}
      sx={{
        color: `var(--${plan.color})`,
        backgroundColor: `var(--${plan.backgroundColor})`,
        ...sx
      }}
      onDelete={onDelete}
      deleteIcon={onDelete ? <CancelIcon /> : undefined}
    />
  )
}

export default PlanChip
